<template>
  <div class="backup-devices">
    <ContentBlock>
      <TableWithPagination
        :tableData="targetLists"
        :columnList="orderTableColumns"
        :pagination.sync="pagination"
        @size-change="getTargetLists"
        @current-change="getTargetLists"
      ></TableWithPagination>
    </ContentBlock>
    <el-dialog
      top="5vh"
      width="950px"
      v-if="isShow"
      :visible.sync="isShow"
      :fullscreen="isFullscreen"
      :close-on-click-modal="false"
      @closed="isShow = false"
      :append-to-body="true"
      :show-close="false"
      class="send-repair-detail-dialog"
    >
      <div slot="title" class="dialog-title">
        <span>备用机详情</span>
        <div class="titleButtonContainer">
          <vxe-button type="text" @click="isFullscreen = !isFullscreen">
            <img :src="require('@/assets/table/ic_zhankai.svg')" v-if="isFullscreen" />
            <img :src="require('@/assets/table/ic_shouqi.svg')" v-else />
          </vxe-button>
          <vxe-button type="text" icon="vxe-icon-close" @click="isShow = false"></vxe-button>
        </div>
      </div>
      <div class="send-repair-detail-dialog-content">
        <BackupDeviceDetail :id="currentId"></BackupDeviceDetail>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { setOrderTableColumns } from './config/index';
import { sendRepairPageList } from '@/api/RFQ';
import BackupDeviceDetail from '@/views/RFQ/logistics/backupDevice/detail.vue';

export default {
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
    BackupDeviceDetail,
  },
  props: {
    code: {
      type: String,
      required: true,
    },
    cooperationLedgerId: {
      type: String,
      default: '',
    },
  },
  computed: {
    orderTableColumns () {
      return setOrderTableColumns.call(this);
    },
  },
  watch: {
    code: {
      handler () {
        this.init();
        this.getTargetLists();
      },
    },
  },
  data () {
    return {
      targetLists: [],
      detail: {},
      isShow: false,
      isFullscreen: false,
      currentId: '',
    };
  },
  methods: {
    init () {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = 10;
      this.targetLists = [];
      this.pagination.total = 0;
    },
    handleShowDetail (row) {
      this.currentId = row.id;
      this.isShow = true;
    },
    async getTargetLists () {
      if (!this.code) {
        return;
      }

      let params = {
        inquirePriceCode: this.code,
        cooperationLedgerId: this.cooperationLedgerId,
        type: 2, // 备用机
        findRecordFlag: true,
        orderBy: [
          {
            orderByProperty: 'createTime',
            orderByType: 'DESC',
          },
        ],
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };

      const { body } = await sendRepairPageList(params);
      this.pagination.total = body.total * 1 || 0;
      this.targetLists = body.list || [];
    },
  },
  mounted () {
    this.getTargetLists();
  },
};
</script>
<style lang="scss" scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}

.send-repair-detail-dialog {
  .dialog-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: bold;
  }
  .send-repair-detail-dialog-content {
    max-height: calc(100vh - 5vh - 200px);
    overflow: auto;
    margin-bottom: 30px;
  }
}

/deep/ .vxe-cell {
  .c_tag {
    @include tag_round();
    margin-right: 0.2em;
  }

  .status-2,
  .status-3 {
    background-color: #fefae0;
    color: #fab007;

    &:before {
      color: #fab007;
    }
  }

  .status-4,
  .status-1 {
    background: #e2f3fe;
    color: #237ffa;

    &:before {
      color: #237ffa;
    }
  }

  .status-5 {
    background: #e5feeb;
    color: #14ca64;

    &:before {
      color: #14ca64;
    }
  }

  .status-8 {
    background-color: #f2f4f7;
    color: #1f2733;

    &:before {
      color: #1f2733;
    }
  }
}
</style>
